import { useMask } from "@react-input/mask";

export const useMasks = () => {
  const maskPhone = useMask({
    mask: "(__) _ ____-____",
    replacement: { _: /\d/ },
    modify: (e) => {
      return {
        mask:
          e.value.replace(/\D/g, "").length < 11
            ? "(__) ____-_____"
            : undefined,
      };
    },
  });

  const maskMobile = useMask({
    mask: "(__) _ ____-____",
    replacement: { _: /\d/ },
    modify: (e) => {
      return {
        mask:
          e.value.replace(/\D/g, "").length < 11
            ? "(__) ____-_____"
            : undefined,
      };
    },
  });

  const maskCnpj = useMask({
    mask: "AA.AAA.AAA/AAAA-00",
    replacement: { A: /[0-9a-zA-Z]/, 0: /\d/ },
  });

  const maskCpf = useMask({
    mask: "___.___.___-__",
    replacement: { _: /\d/ },
  });

  const maskCep = useMask({
    mask: "_____-___",
    replacement: { _: /\d/ },
  });

  const maskVersion = useMask({
    mask: "0.0.0",
    replacement: { 0: /\d/ },
  });

  return { maskPhone, maskMobile, maskCnpj, maskCpf, maskCep, maskVersion };
};
